import { Popover, Text, Box } from '@mantine/core'
import { useDisclosure, useLocalStorage, useTimeout } from '@mantine/hooks'
import React, { useEffect } from 'react'
import { COLOR_NAMES, FONT_STACK } from 'Theme'

export const AddToFavoritesHintPopover = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [hasSeenHint, setHasSeenHint] = useLocalStorage({
    key: 'seen-favorite-hint',
    defaultValue: false,
    getInitialValueInEffect: false,
  })

  const [isOpened, { open, close }] = useDisclosure(false)

  const { start, clear } = useTimeout(close, 10000)

  useEffect(() => {
    if (!hasSeenHint) {
      open()
      start()
      setHasSeenHint(true)
    }
  }, [hasSeenHint, open, start, setHasSeenHint])

  const handleManualClose = () => {
    clear()
    close()
  }

  return (
    <Popover
      width={140}
      trapFocus={false}
      position="top"
      withArrow
      arrowSize={12}
      opened={isOpened}
      onClose={handleManualClose}
      zIndex={9}
      styles={{
        dropdown: {
          backgroundColor: COLOR_NAMES.PINEY_LAKE,
          padding: '8px 8px',
          borderRadius: 6,
        },
        arrow: { backgroundColor: COLOR_NAMES.PINEY_LAKE },
      }}
    >
      <Popover.Target>
        <Box>{children}</Box>
      </Popover.Target>
      <Popover.Dropdown>
        <Text size="sm" c="white" ff={FONT_STACK.SANS} fw={500} ta="center">
          Save to favorites
        </Text>
      </Popover.Dropdown>
    </Popover>
  )
}
